<template>
  <v-container id="user-list">
    <v-row>
      <v-col><h2>Gestão de Usuário</h2></v-col>
      <v-col class="text-right">
        <v-btn outlined color="primary" class="ml-3" :to="'/usuario'">
          Voltar para Lista de Usuários
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Nome do usuário*"
          name="nome"
          type="text"
          required
          v-model="usuario.nome"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-group-combobox
          :filter="usuario"
          :idsToFilter="groupsHierarquia"
          placeholderName="Grupo*"
        >
        </app-group-combobox>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="usuario.ats"
          id="ats"
          color="primary"
          label="Atua como ATS"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="E-mail*"
          name="email"
          type="email"
          required
          v-model="usuario.email"
        ></v-text-field>
      </v-col>
    </v-row>

    <template v-if="maisdados">
      <v-row>
        <v-col>
          <v-text-field
            label="CPF"
            name="cpf"
            type="text"
            required
            v-mask="'###.###.###-##'"
            v-model="usuario.cpf"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            label="Telefone"
            name="telefone"
            type="text"
            required
            v-mask="['(##) ####-####', '(##) #####-####']"
            v-model="usuario.telefone"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            label="CNPJ"
            name="cnpj"
            type="text"
            required
            v-mask="'##.###.###/####-##'"
            v-model="usuario.cnpj"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            label="Razão Social"
            name="razaosocial"
            type="text"
            required
            autocomplete="nope"
            v-model="usuario.razaoSocial"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="isFullAdmin">
        <v-col>
          <v-text-field
            label="Senha"
            name="senha"
            type="password"
            required
            autocomplete="new-password"
            v-model="usuario.senha"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col>
        <v-btn color="info" outlined text @click="maisdados = !maisdados"
          >{{ maisdados ? "Fechar " : "" }} Dados Complementares
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h2>PERMISSÕES</h2>
        <v-divider> </v-divider>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <combobox-unidade-regional
          :filter="permissao"
        ></combobox-unidade-regional>
      </v-col>

      <v-col>
        <municipio-combo
          :filter="permissao"
          @allMunicipio="(e) => (allMunicipio = e)"
        ></municipio-combo>
      </v-col>

      <v-col v-if="permissao.municipio.length">
        <app-axis-by-project-combobox :filter="permissao">
        </app-axis-by-project-combobox>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="addPermission">
          Adicionar Permissão
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="delete">
        <v-btn
          outlined
          color="error"
          class="mr-3"
          :disabled="!usuario.permissoes.length"
          @click="removeAllPermission()"
        >
          <v-icon>mdi-trash-can-outline</v-icon> Deletar Todos
        </v-btn>
        <v-btn
          outlined
          color="error"
          class="mr-3"
          :disabled="!selectionItems.length"
          @click="removePermission()"
        >
          <v-icon>mdi-trash-can-outline</v-icon> Deletar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuario.permissoes"
          class="elevation-1"
          ref="table"
          :items-per-page="5"
          :search="search"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': 'Items por página',
          }"
        >
          <template v-slot:header.selection="{ header }">
            <v-checkbox
              v-model="allSelected"
              color="primary"
              @change="
                usuario.permissoes = usuario.permissoes.map((item) => {
                  return {
                    ...item,
                    selection: !!allSelected,
                  };
                })
              "
            >
            </v-checkbox>
          </template>

          <template slot="no-data">
            <span> Nenhuma permissão encontrada </span>
          </template>

          <template v-slot:item.selection="{ item, index }">
            <v-checkbox
              color="primary"
              v-model="item.selection"
              @change="
                usuario.permissoes = usuario.permissoes.map((item, i) => {
                  if (index === i) {
                    item.selection = $event;
                  }
                  return item;
                })
              "
            >
            </v-checkbox>
          </template>

          <template v-slot:item.eixo="{ item }">
            <app-axis-by-project-combobox :filter="item">
            </app-axis-by-project-combobox>
          </template>

          <template v-slot:item.actions="{ item, index }">
            <v-btn
              outlined
              color="error"
              class="mr-3"
              @click="removeOnePermission({ item })"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>

          <template v-slot:top>
            <div style="padding: 10px">
              <h6>Filtros</h6>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquise..."
              ></v-text-field>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row class="delete">
      <v-btn outlined color="primary" class="ml-3" @click="updateUser">
        Atualizar Usuário
      </v-btn>
    </v-row>

    <v-row v-if="!usuario.arrayArquivoAssinatura">
      <v-col>
        <v-file-input
          label="Envie sua assinatura eletrônica"
          v-model="usuario.arquivoAssinatura"
        >
        </v-file-input>
      </v-col>
    </v-row>

    <v-row v-if="usuario.arrayArquivoAssinatura">
      <v-col>
        <v-file-input
          label="Atualize sua assinatura eletrônica"
          v-model="usuario.arquivoAssinatura"
        >
        </v-file-input>
      </v-col>
    </v-row>

    <v-row v-if="usuario.arquivoAssinatura">
      <v-btn outlined color="primary" class="ml-3" @click="sendSignature">
        Enviar Assinatura Eletrônica
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { userAPI } from "./UserAPI";
import { groupsAPI } from "@/modules/groups";

import { AppGroupCombobox, AppPermissionCombobox } from "@/modules/user";
import { AppAxisByProjectCombobox } from "@/modules/axis";
import { mapActions, mapGetters } from "vuex";
import MunicipioCombo from "./MunicipioCombo.vue";
import ComboboxEixoGrupo from "./ComboboxEixoGrupo.vue";
import { axisAPI } from "@/modules/axis";
import ComboboxUnidadeRegional from "@/modules/ur/components/Combobox.vue";

export default {
  components: {
    AppGroupCombobox,
    AppPermissionCombobox,
    AppAxisByProjectCombobox,
    MunicipioCombo,
    ComboboxEixoGrupo,
    ComboboxUnidadeRegional,
  },
  data() {
    return {
      usuario: {
        nome: "",
        grupo: {
          nome: "",
        },
        grupoId: 0,
        cpf: "",
        email: "",
        senha: "",
        permissoes: [],
      },
      headers: [
        { text: "", value: "selection", sortable: false, width: "5%" },
        { text: "Município", value: "municipio.nome" },
        { text: "Eixos", value: "eixo", width: "30%", sortable: false },
        { text: "Ações", value: "actions", width: "10%", sortable: false },
      ],
      grupos: [],
      permissoes: [],
      groupsHierarquia: [],
      allSelected: false,
      search: "",
      listaEixos: [],
      maisdados: false,
      permissao: {
        municipioId: null,
        municipio: [],
        permissaoId: null,
        permissao: {},
        eixoId: null,
        eixo: [],
        selection: false,
      },
      user: JSON.parse(localStorage.getItem("user")),
      allMunicipio: [],
    };
  },
  watch: {
    "permissao.id_unidade_regional"(val) {
      if (val) {
        this.permissao.municipio = this.allMunicipio.filter(
          (item) => item.id_unidade_regional == val
        );
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    getUser() {
      this.setLoading(true);
      userAPI
        .findUser(this.$route.params.id)
        .then((resp) => {
          this.usuario = resp.data;

          this.usuario.permissoes.forEach((per, index) => {
            if (!Array.isArray(per.eixo)) {
              const aux = per.eixo;
              this.usuario.permissoes[index].eixo = [];
              this.usuario.permissoes[index].eixo.push(aux);
            }

            this.usuario.permissoes[index].selection = false;
          });

          this.usuario.permissoes = Object.values(
            this.usuario.permissoes.reduce((acc, curr) => {
              if (!acc[curr.municipioId]) {
                acc[curr.municipioId] = {
                  ...curr,
                  eixo: curr.eixo,
                };
              } else {
                acc[curr.municipioId].eixo = [
                  ...acc[curr.municipioId].eixo,
                  ...curr.eixo,
                ];
              }

              return acc;
            }, {})
          );

          this.getHierarquia(this.user.grupoId);
        })
        .catch((resp) => {
          console.log("Erro ao listar permissões: ", resp);

          this.setLoading(false);
          this.$notification.error("Erro ao obter usuário");
        });
    },
    getEixos() {
      axisAPI
        .list()
        .then((resp) => {
          this.listaEixos = resp.data;
        })
        .catch();
    },
    getHierarquia(groupId) {
      groupsAPI
        .getOne(groupId)
        .then((resp) => {
          const { hierarquia } = resp.data;
          this.groupsHierarquia = hierarquia && JSON.parse(hierarquia);

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao achar hierarquia usuário");
        });
    },
    updateUser() {
      this.setLoading(true);
      let novoUsuario = [];

      this.usuario.permissoes.forEach((item) => {
        delete item.municipio.imagemMunicipioBlob;
        if (item.eixo.length > 0) {
          item.eixo.forEach((ei) => {
            novoUsuario.push({
              ...item,
              eixo: ei,
            });
          });
        } else {
          this.listaEixos.forEach((ei) => {
            novoUsuario.push({
              ...item,
              eixo: ei,
            });
          });
        }
      });

      let usuarioFinal = { ...this.usuario, permissoes: novoUsuario };

      if (this.$store.state.uf == "SP" && usuarioFinal.cpf) {
        usuarioFinal.cpf = usuarioFinal.cpf.replace(/\D/g, "");
      }
      userAPI
        .updateUser(usuarioFinal)
        .then((resp) => {
          this.$notification.success("Usuário atualizado com sucesso!");
          this.getUser();
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao atualizar usuario ", err);
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar usuário");
        });
    },
    addPermission() {
      let multiplesMunicipios = [];
      let multiplesEixos = [];
      let multiplesMunicipiosEixos = [];

      var permissoesHash = this.usuario.permissoes.reduce((acc, curr) => {
        acc[curr.municipioId] = curr;
        return acc;
      }, {});

      if (
        this.permissao.municipio &&
        this.permissao.municipio.length &&
        this.permissao.eixo &&
        this.permissao.eixo.length
      ) {
        this.permissao.permissao = {
          nome: "Consultor Especialista",
          permissaoId: 3,
        };

        this.permissao.permissaoId = 3;

        this.permissao.municipio.forEach((item) => {
          this.permissao.municipioId = item.municipioId;
          if (!permissoesHash[item.municipioId]) {
            permissoesHash[item.municipioId] = {
              ...this.permissao,
              municipio: item,
              eixo: this.permissao.eixo,
            };
          } else {
            var eixos = this.permissao.eixo.filter((ei) =>
              permissoesHash[item.municipioId].eixo.every(
                (eixo) => ei.eixoId != eixo.eixoId
              )
            );

            permissoesHash[item.municipioId].eixo = [
              ...permissoesHash[item.municipioId].eixo,
              ...eixos,
            ];
          }
        });

        Object.values(permissoesHash).forEach((item) => {
          multiplesMunicipiosEixos.push(item);
        });

        this.usuario.permissoes = multiplesMunicipiosEixos;
      } else if (this.permissao.municipio && this.permissao.municipio.length) {
        this.permissao.permissao = {
          nome: "Consultor Especialista",
          permissaoId: 3,
        };
        this.permissao.permissaoId = 3;

        this.permissao.municipio.forEach((item) => {
          this.permissao.municipioId = item.municipioId;
          if (!permissoesHash[item.municipioId]) {
            permissoesHash[item.municipioId] = {
              ...this.permissao,
              municipioId: item.municipioId,
              municipio: item,
              eixo: [],
            };
          }
        });

        Object.values(permissoesHash).forEach((item) => {
          multiplesMunicipios.push(item);
        });

        this.usuario.permissoes = multiplesMunicipios;
      } else if (this.permissao.eixo && this.permissao.eixo.length) {
        this.permissao.permissao = null;

        if (!permissoesHash[null]) {
          permissoesHash[null] = {
            ...this.permissao,
            municipioId: null,
            municipio: [],
            eixo: this.permissao.eixo,
          };
        } else {
          var eixos = this.permissao.eixo.filter((ei) =>
            permissoesHash[null].eixo.every((eixo) => ei.eixoId != eixo.eixoId)
          );

          permissoesHash[null] = {
            ...permissoesHash[null],
            eixo: [...permissoesHash[null].eixo, ...eixos],
          };
        }

        Object.values(permissoesHash).forEach((item) => {
          multiplesEixos.push(item);
        });

        this.usuario.permissoes = multiplesEixos;

        this.permissao = {
          municipioId: null,
          municipio: [],
          permissaoId: null,
          permissao: null,
          eixoId: null,
          eixo: [],
          selection: false,
        };
      }
    },
    changePermission() {
      this.permissao.permissaoId = this.permissao.permissao.permissaoId;
    },
    removePermission() {
      this.usuario.permissoes = this.notSelectionItems;
    },
    removeAllPermission() {
      this.usuario.permissoes = [];
    },
    removeOnePermission({ item }) {
      this.usuario.permissoes.forEach((val, index) => {
        if (item == val) {
          this.usuario.permissoes.splice(index, 1);
        }
      });
    },
    sendSignature() {
      this.setLoading(true);

      let formData = new FormData();

      formData.append("arquivoAssinatura", this.usuario.arquivoAssinatura);
      formData.append("usuarioId", this.usuario.usuarioId);

      userAPI
        .sendSignature(formData)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Assinatura eletrônica salva com sucesso");
          this.getUser();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar assinatua eletrônica");
        });
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isGov"]),

    selectionItems() {
      return this.usuario.permissoes.filter((item) => item.selection);
    },
    notSelectionItems() {
      return this.usuario.permissoes.filter((item) => !item.selection);
    },
  },
  mounted() {
    this.getUser();
    this.getEixos();

    if (this.isGov) {
      this.headers = [
        { text: "", value: "selection", sortable: false, width: "5%" },
        { text: "Projeto", value: "municipio.nome" },
        { text: "Eixos", value: "eixo", width: "30%", sortable: false },
        { text: "Ações", value: "actions", width: "10%", sortable: false },
      ];
    }
  },
};
</script>
<style scoped>
.delete {
  display: flex;
  justify-content: flex-end;
}
</style>
